import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import { UsageWarningBanner } from './UsageMeter';
import KeyboardShortcutsModal from './KeyboardShortcutsModal';
import SupportWidget from './SupportWidget';
import LanguageSwitcher from './LanguageSwitcher';

export default function Layout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const mainRef = useRef(null);
  const footerRef = useRef(null);

  // Track viewport size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const marginLeft = isMobile ? 0 : sidebarCollapsed ? '4rem' : '15rem';

  return (
    <div className="min-h-screen bg-navy-900 flex flex-col">
      <KeyboardShortcutsModal />
      <Sidebar onCollapsedChange={setSidebarCollapsed} />

      <main
        ref={mainRef}
        className="flex-1"
        style={{ marginLeft, transition: 'margin-left 300ms ease' }}
      >
        <UsageWarningBanner />
        {/* pt-16 on mobile to clear fixed hamburger button; normal padding on desktop */}
        <div className="p-4 pt-16 sm:p-6 lg:p-8 lg:pt-8 max-w-[1400px]">
          {children}
        </div>
      </main>

      <footer
        ref={footerRef}
        className="border-t border-navy-600 px-4 sm:px-6 lg:px-8 py-4"
        style={{ marginLeft, transition: 'margin-left 300ms ease' }}
      >
        <div className="max-w-[1400px] flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-xs text-slate-600">&copy; 2026 NVISION Group</span>
          <div className="flex items-center gap-4">
            <a href="https://airesepsjonen.no/personvern" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-600 hover:text-slate-400 transition-colors">Personvern</a>
            <a href="https://airesepsjonen.no/vilkar" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-600 hover:text-slate-400 transition-colors">Vilkår</a>
            <a href="mailto:support@airesepsjonen.no" className="text-xs text-slate-600 hover:text-slate-400 transition-colors">Kontakt oss</a>
            <LanguageSwitcher />
          </div>
        </div>
      </footer>

      {/* Floating support widget — always available bottom-right */}
      <SupportWidget />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};
